(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

require('./app/init');

require('./app/polyfills');

require('./app/search');

require('./app/video');

require('./app/owl');

require('./app/scroll');

require('./app/modal');

require('./app/form');

require('./app/input-number');

require('./app/input-file');

require('./app/download-links');

require('./app/royalSlider');

require('./app/form-pentest');

require('./app/mobile-menu');

require('./app/accordion');

require('./app/dropdown');

require('./app/cards');

require('./app/tabs');

require('./app/dragscroll');

require('./app/banner');

require('./app/lazy-load');

require('./app/socials');

require('./app/loadmore');

require('./app/up-link');

require('./app/common');

require('./app/configurator');

require('./app/range-slider');

require('./app/calculate-form');

require('./app/glossary');

require('./app/rating');

require('./app/quiz');

require('./app/filters');

require('./app/map');

require('./app/form-sections');

require('./app/bench');

require('./app/calculator');

},{"./app/accordion":2,"./app/banner":3,"./app/bench":4,"./app/calculate-form":5,"./app/calculator":6,"./app/cards":7,"./app/common":8,"./app/configurator":9,"./app/download-links":10,"./app/dragscroll":11,"./app/dropdown":12,"./app/filters":13,"./app/form":16,"./app/form-pentest":14,"./app/form-sections":15,"./app/glossary":17,"./app/init":18,"./app/input-file":19,"./app/input-number":20,"./app/lazy-load":21,"./app/loadmore":22,"./app/map":23,"./app/mobile-menu":24,"./app/modal":25,"./app/owl":26,"./app/polyfills":27,"./app/quiz":28,"./app/range-slider":29,"./app/rating":30,"./app/royalSlider":31,"./app/scroll":32,"./app/search":33,"./app/socials":34,"./app/tabs":35,"./app/up-link":36,"./app/video":38}],2:[function(require,module,exports){
"use strict";

(function (window, document, $) {
  var $accordion = $('.accordion');

  if ($accordion) {
    $('.accordion__expand').on('click', function (e) {
      var $btn = $(this);
      var $title = $btn.find('i');
      var $parent = $btn.parent();
      $btn.toggleClass('expanded');

      if ($btn.hasClass('expanded')) {
        $parent.find('.collapse').collapse('show');
        $title.text($btn.data('collapse'));
      } else {
        $parent.find('.collapse').collapse('hide');
        $title.text($btn.data('expand'));
      }
    });
    $accordion.on('hide.bs.collapse', function () {
      if ($(this).find('.show').length === 1) {
        var $btn = $(this).find('.accordion__expand');
        $btn.removeClass('expanded').find('i').text($btn.data('expand'));
      }
    });
    $accordion.on('show.bs.collapse', function () {
      if ($(this).find('.collapse:not(.show)').length === 1) {
        var $btn = $(this).find('.accordion__expand');
        $btn.addClass('expanded').find('i').text($btn.data('collapse'));
      }
    });
  }
})(window, document, jQuery);

},{}],3:[function(require,module,exports){
"use strict";

(function (window, document, $) {
  var $banner = $('.banner');

  if ($banner) {
    var setBannerCookies = function setBannerCookies(dataBanner) {
      var cookieName = dataBanner === 'locale' ? 'qtrans_front_language_picked' : "itglobal_banner_".concat(dataBanner, "_viewed");
      Cookies.set(cookieName, 'on', {
        expires: 30,
        path: '/'
      });
    };

    $banner.find('a').on('click', function () {
      var dataBanner = $(this).closest('.banner').attr('data-banner');
      setBannerCookies(dataBanner);
    });
    $('.btn-no').on('click', function () {
      var $banner = $(this).closest('.banner');
      var $text = $banner.find('.banner-empty__text');
      $banner.find('.banner-locale__entry').css('display', 'none');
      $banner.find('.banner-locale__langs').addClass('show');
      $text.text($text.data('text'));
    });
    $('button.close, #close-picker').on('click', function () {
      var $banner = $(this).closest('.banner');
      $banner.slideUp();
      setBannerCookies($banner.attr('data-banner'));
    });
  }
})(window, document, jQuery);

},{}],4:[function(require,module,exports){
"use strict";

var _functions = require("../modules/_functions");

var bench = document.querySelector('.bench');

if (bench) {
  var lines = bench.querySelectorAll('.bench__line') || [];

  var pursuit = function pursuit() {
    lines.forEach(function (line) {
      if ((0, _functions.inViewport)(line)) {
        line.classList.add('bench__line--pursuit');
        line.querySelector('.bench__title').classList.add('bench__title--show');
        line.querySelector('.bench__value').classList.add('bench__value--show');
      }
    });
  };

  pursuit();
  document.addEventListener('scroll', pursuit);
}

},{"../modules/_functions":39}],5:[function(require,module,exports){
"use strict";

var btn = document.querySelector('.calculate-form__btn');
var inputs = document.querySelectorAll('.calculate-form input');

var inputChange = function inputChange(e) {
  var disabled = true;

  for (var i = 0; i < inputs.length; i++) {
    var type = inputs[i].type;
    var value = inputs[i].value;

    if (type === 'text' && value !== '' && value !== '0') {
      disabled = false;
      break;
    } else if (type === 'radio' && inputs[i].checked) {
      disabled = false;
      break;
    } else if (type === 'range' && value !== '0') {
      disabled = false;
      break;
    } else if (type === 'checkbox' && inputs[i].checked === true) {
      disabled = false;
      break;
    }

    disabled = true;
  }

  btn.disabled = disabled;
};

if (inputs.length) {
  inputs.forEach(function (input) {
    input.addEventListener('change', inputChange);
  });
  btn.addEventListener('click', function (e) {
    var target = e.target.getAttribute('data-target');
    var $target = $('' + e.target.getAttribute('data-target') + '');
    $target.on('show.bs.modal', function (e) {
      $('form', this).addClass('calculate-modal');
    });
    $target.on('hide.bs.modal', function (e) {
      $('form', this).removeClass('calculate-modal');
    });
  });
}

},{}],6:[function(require,module,exports){
"use strict";

var calculators = document.querySelectorAll('.calculator');

if (calculators.length > 0) {
  calculators.forEach(function (calc) {
    var rangeControls = calc.querySelectorAll('[data-role="range-btn"]');
    var rangeInputs = calc.querySelectorAll('.range__text');
    var priceEl = document.getElementById('calc-total');
    rangeControls.forEach(function (control) {
      control.addEventListener('click', function () {
        var currRange = control.closest('.range').querySelector('.range__text');
        var currValue = parseInt(currRange.value);
        currRange.value = control.dataset.direction === 'plus' && currValue < currRange.max ? currValue + parseInt(currRange.step) : control.dataset.direction === 'minus' && currValue > currRange.min ? currValue - parseInt(currRange.step) : currValue;
        updatePrice();
        updateSelected(currRange);
      });
    });
    rangeInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        updatePrice();
        updateSelected(input);
      });
    });

    var updatePrice = function updatePrice() {
      var price = 0;
      calc.querySelectorAll('.calculator__row').forEach(function (row) {
        if (row.dataset.price) {
          price += row.dataset.price * row.querySelector('.range__text').value;
        }
      });
      priceEl.innerText = price;
    };

    var updateSelected = function updateSelected(range) {
      var selected = document.getElementById('calc-selected');

      if (!document.getElementById(range.name) && range.value !== '0') {
        selected.insertAdjacentHTML('beforeend', '<div class="calculator__grid" id="' + range.name + '"><span id="range-title-' + range.name + '">' + range.title + '</span><span id="range-count-' + range.name + '" class="hidden">' + range.value + '</span><span id="range-price-' + range.name + '">' + range.dataset.price * range.value + ' ' + range.dataset.suffix + '</span><button type="button" class="remove">' + removeIcon + '</button></div>');
        document.querySelectorAll('.remove').forEach(function (close) {
          close.addEventListener('click', function () {
            var id = close.closest('.calculator__grid').id;
            close.closest('.calculator__grid').remove();
            document.querySelector('[name="' + id + '"]').value = 0;
            updatePrice();
          });
        });
      } else {
        if (document.getElementById(range.name) && range.value === '0') {
          document.getElementById(range.name).remove();
        } else {
          if (document.getElementById('range-price-' + range.name)) {
            document.getElementById('range-price-' + range.name).innerText = range.dataset.price * range.value + ' ' + range.dataset.suffix;
            document.getElementById('range-count-' + range.name).innerText = range.value;
            var name = document.getElementById('range-title-' + range.name);
            name.innerText = name.innerText.replace(/^.+?\s/, range.value + ' ');
          }
        }
      }
    };

    var calcBtn = document.querySelector('.calculator__btn');
    calcBtn.addEventListener('click', function () {
      var modal = document.querySelector(calcBtn.dataset.target);
      var submit = modal.querySelector('button[type="submit"]');
      submit.insertAdjacentHTML('beforeBegin', '<div class="calculator__modal"></div>');
      var modalRow = document.querySelector('.calculator__modal');
      modalRow.innerHTML = '';
      document.querySelectorAll('.calculator__grid').forEach(function (item) {
        var price = document.getElementById('range-price-' + item.id);
        var count = document.getElementById('range-count-' + item.id);
        var name = count.previousElementSibling.innerText;
        var nameActual = name.replace(/^.+?\s/, count.innerText + ' ');
        modalRow.insertAdjacentHTML('beforeEnd', '<div class="calculator__modal-row"><span>' + nameActual + '</span><span>' + price.innerText + '</span></div>');
        modalRow.insertAdjacentHTML('beforeEnd', '<input type="hidden" name="' + item.id + '" value="' + price.innerText + '">');
      });
    });
  });
  var removeIcon = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<g clip-path="url(#clip0_49847_51178)">\n' + '<path fill-rule="evenodd" clip-rule="evenodd" d="M7.29293 8.00001L1.64648 2.35356L2.35359 1.64645L8.00004 7.2929L13.6465 1.64645L14.3536 2.35356L8.70714 8.00001L14.3536 13.6465L13.6465 14.3536L8.00004 8.70711L2.35359 14.3536L1.64648 13.6465L7.29293 8.00001Z" fill="#338FFA" stroke="#338FFA"/>\n' + '</g>\n' + '<defs>\n' + '<clipPath id="clip0_49847_51178">\n' + '<rect width="16" height="16" fill="white"/>\n' + '</clipPath>\n' + '</defs>\n' + '</svg>';
}

},{}],7:[function(require,module,exports){
"use strict";

(function (window, document, $) {
  var $serviceCards = $('.card.card--sm');
  var $blogCards = $('.blog-card, .card');
  var $eventCards = $('.card-event');
  $(document).delegate('a', 'mouseover', function () {
    $(this).find('.link').addClass('hovered');
  }).delegate('a', 'mouseleave', function () {
    $(this).find('.link').removeClass('hovered');
  });

  if ($eventCards.length) {
    $eventCards.each(function () {
      var maxHeight = 100;
      var $text = $(this).find('.card__txt');

      if ($text.innerHeight() >= maxHeight) {
        $text.addClass('hide-text');
      }
    });
  }
})(window, document, jQuery);

},{}],8:[function(require,module,exports){
"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (window, document, $) {
  $('.important--checked .important__item').has('h3').addClass('-t');
  window.addEventListener("load", function () {
    if ((typeof VK === "undefined" ? "undefined" : _typeof(VK)) === 'object') {
      VK.Goal('page_view');
    }
  });
})(window, document, jQuery);

},{}],9:[function(require,module,exports){
"use strict";

var icons = document.querySelectorAll('.configurator-icon');

if (icons.length) {
  var tooltipClass = 'tooltip-custom';
  icons.forEach(function (item) {
    item.addEventListener('mouseover', function (e) {
      var text = item.getAttribute('data-title');
      var tooltip = document.querySelector('.' + tooltipClass + '');

      if (tooltip && tooltip !== item.previousElementSibling) {
        tooltip.remove();
      }

      if (!item.previousElementSibling) {
        item.insertAdjacentHTML('beforeBegin', '<div class="' + tooltipClass + '"><div class="tooltip-custom__inner">' + text + '</div></div>');
        tooltip = document.querySelector('.' + tooltipClass + '');
      }

      if (tooltip) {
        setTimeout(function () {
          tooltip.classList.add('active');
        }, 10);
        tooltip.addEventListener('mouseout', function (e) {
          if (!e.relatedTarget.classList.contains('configurator-icon')) {
            tooltip.remove();
          }
        });
      }
    });
    item.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget.closest('.' + tooltipClass + '') && item.previousElementSibling) {
        item.previousElementSibling.remove();
      }
    });
  });
}

var configuratorForm = document.forms['configurator-form'];

if (configuratorForm) {
  var checkedOption = configuratorForm.querySelector('input:checked');
  checkedOption.disabled = false;
  var indexChecked = checkedOption.closest('th').getAttribute('data-index');
  configuratorForm.querySelectorAll('td[data-index="' + indexChecked + '"] input').forEach(function (input) {
    input.disabled = false;
  });
  var confRadio = document.querySelectorAll('input[name="configurator-equipment"]');
  var configuratorFields = configuratorForm.querySelectorAll('input');
  var checkboxFields = configuratorForm.querySelectorAll('input[type="checkbox"]');
  var bottom = configuratorForm.querySelector('.configurator-form__bottom');
  var btns = configuratorForm.querySelectorAll('.configurator-form__btn');
  var checkboxNames = {};
  checkboxFields.forEach(function (input) {
    if (input.getAttribute('data-number') < 4) {
      checkboxNames[input.getAttribute('data-key')] = input.getAttribute('data-key');
    }
  });

  var sendFunction = function sendFunction(addData) {
    var data = new FormData(configuratorForm);
    var newData = [];

    if (addData) {
      for (var key in addData) {
        if (addData[key]) {
          newData.push(key.replace('optional-', ''));
        }
      }
    }

    if (newData.length) {
      data.append('checkedGroups', newData);
    }

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/ajax/configurator.php', true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.send(data);

    xhr.onreadystatechange = function () {
      if (xhr.readyState === xhr.DONE && xhr.status === 200) {
        var response = JSON.parse(xhr.responseText);

        if (response) {
          var tooltip = bottom.querySelector('.configurator-form__tooltip');

          if (tooltip) {
            tooltip.remove();
          }

          if (response['tooltip']) {
            bottom.insertAdjacentHTML('afterbegin', '<div class="configurator-form__tooltip">' + response['tooltip'] + '</div>');
          }

          configuratorForm.querySelector('input[name="configurator-license"]').value = response.license;
          document.getElementById('configurator-license').innerText = response.license;

          if (!response.noPrice) {
            configuratorForm.querySelector('input[name="configurator-price"]').value = response.price;
            document.getElementById('configurator-price').innerText = response.price;
          }
        }
      }
    };
  };

  var inputChange = function inputChange(e) {
    var checkedObj = {};

    for (name in checkboxNames) {
      var currentInputGroup = document.querySelectorAll('input[data-key="' + name + '"]');

      for (var i = 0; i < currentInputGroup.length; i++) {
        checkedObj[currentInputGroup[i].getAttribute('data-key')] = true;

        if (currentInputGroup[i].checked === false) {
          checkedObj[currentInputGroup[i].getAttribute('data-key')] = false;
          break;
        }
      }
    }

    sendFunction(checkedObj);
  };

  confRadio.forEach(function (btn) {
    btn.addEventListener('change', function (e) {
      var index = e.target.closest('th').getAttribute('data-index');
      checkboxFields.forEach(function (input) {
        input.checked = false;
        input.disabled = true;
      });
      configuratorForm.querySelectorAll('td[data-index="' + index + '"] input').forEach(function (input) {
        input.disabled = false;
      });
    });
  });
  btns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var $target = $('' + e.target.getAttribute('data-target') + '');
      $target.on('show.bs.modal', function (e) {
        $('form', this).addClass('configurator-modal');
      });
      $target.on('hide.bs.modal', function (e) {
        $('form', this).removeClass('configurator-modal');
      });
    });
  });
}

},{}],10:[function(require,module,exports){
"use strict";

var _utils = require("./utils");

(function () {
  var data = {
    'ebook': '',
    'id': '',
    'locale': '',
    'action': 'download'
  };
  var $body = $('body');
  var ymGoal = '';
  $body.on('click', '[data-download].allowed', function () {
    data.donwloadId = $(this).attr('data-id') || $(this).attr('data-download');
    data.locale = $(this).attr('data-locale');
    data.download = false;
    var $modal = $('#successModal');
    ymGoal = $(this).attr('data-goal-ym');
    $.post('/wp-admin/admin-ajax.php', data, function (response) {
      response = JSON.parse(response);
      var $message = $modal.find('.response-message');

      if ($message.length === 0) {
        $modal.find('.modal-content').append('<div class="response-message"></div>').html(response.message);
      } else {
        $modal.find('.response-message').html(response.message);
      }
    });
  });
  $body.on('click', '.download-btn', function () {
    data.download = true;
    data.title = $(this).find('.download-title').text();
    $.post('/wp-admin/admin-ajax.php', data, function (response) {
      response = JSON.parse(response);
      if (response.goals && response.goals.ym) (0, _utils.sendGoals)(response.goals.ym);
    });
  });
})();

},{"./utils":37}],11:[function(require,module,exports){
"use strict";

/**
 * @fileoverview dragscroll - scroll area by dragging
 * @version 0.0.8
 * 
 * @license MIT, see http://github.com/asvd/dragscroll
 * @copyright 2015 asvd <heliosframework@gmail.com> 
 */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== 'undefined') {
    factory(exports);
  } else {
    factory(root.dragscroll = {});
  }
})(void 0, function (exports) {
  var _window = window;
  var _document = document;
  var mousemove = 'mousemove';
  var mouseup = 'mouseup';
  var mousedown = 'mousedown';
  var EventListener = 'EventListener';
  var addEventListener = 'add' + EventListener;
  var removeEventListener = 'remove' + EventListener;
  var newScrollX, newScrollY;
  var dragged = [];

  var reset = function reset(i, el) {
    for (i = 0; i < dragged.length;) {
      el = dragged[i++];
      el = el.container || el;
      el[removeEventListener](mousedown, el.md, 0);

      _window[removeEventListener](mouseup, el.mu, 0);

      _window[removeEventListener](mousemove, el.mm, 0);
    } // cloning into array since HTMLCollection is updated dynamically


    dragged = [].slice.call(_document.getElementsByClassName('nav-tabs'));

    for (i = 0; i < dragged.length;) {
      (function (el, lastClientX, lastClientY, pushed, scroller, cont) {
        (cont = el.container || el)[addEventListener](mousedown, cont.md = function (e) {
          if (!el.hasAttribute('nochilddrag') || _document.elementFromPoint(e.pageX, e.pageY) == cont) {
            pushed = 1;
            lastClientX = e.clientX;
            lastClientY = e.clientY;
            e.preventDefault();
          }
        }, 0);

        _window[addEventListener](mouseup, cont.mu = function () {
          pushed = 0;
        }, 0);

        _window[addEventListener](mousemove, cont.mm = function (e) {
          if (pushed) {
            (scroller = el.scroller || el).scrollLeft -= newScrollX = -lastClientX + (lastClientX = e.clientX);
            scroller.scrollTop -= newScrollY = -lastClientY + (lastClientY = e.clientY);

            if (el == _document.body) {
              (scroller = _document.documentElement).scrollLeft -= newScrollX;
              scroller.scrollTop -= newScrollY;
            }
          }
        }, 0);
      })(dragged[i++]);
    }
  };

  if (_document.readyState == 'complete') {
    reset();
  } else {
    _window[addEventListener]('load', reset, 0);
  }

  exports.reset = reset;
});

(function () {
  if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
    var tabs = document.querySelectorAll('.nav-tabs');
    tabs.forEach(function (item, key) {
      tabs[key].classList.add('scrollable');
    });
  }
})();

},{}],12:[function(require,module,exports){
"use strict";

(function (window, document, $) {
  var $langDropDown = $('.lang-switcher').find('.dropdown-toggle');

  if ($langDropDown) {
    $langDropDown.on('click', function () {
      $(this).parent().find('.dropdown-menu').toggleClass('show');
    });
    $(document).on('mouseup', function (e) {
      var $langMenu = $('.lang-switcher').find('.dropdown-menu.show');
      var $switcher = $langMenu.parent().find('.dropdown-toggle');

      if (!$langMenu.is(e.target) && $langMenu.has(e.target).length === 0 && !$switcher.is(e.target) && $switcher.has(e.target).length === 0) {
        $langMenu.removeClass('show');
      }
    });
    $('.lang-switcher').find('.dropdown-menu').addClass('d-flex');
  }
})(window, document, jQuery);

},{}],13:[function(require,module,exports){
"use strict";

var _filter = _interopRequireDefault(require("../modules/filter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//const links = document.querySelectorAll('.filter-link');
var filterItems = document.querySelectorAll('.filter-item');

if (filterItems.length) {
  var filterSelect = document.querySelector('.select-filter');
  if (filterSelect.tagName !== 'SELECT') filterSelect = filterSelect.querySelector('select');
  var filter = new _filter.default(filterSelect, filterItems).apply();
}

},{"../modules/filter":40}],14:[function(require,module,exports){
"use strict";

var pentest_fields = document.querySelectorAll('[data-form-field-type="pentest"]'); // very bad solution, need rework but we use

if (pentest_fields.length > 0) {
  Array.prototype.forEach.call(pentest_fields, function (form) {
    var selected_btn = form.querySelector('.dropdown-menu');
    var ip_fields = document.querySelectorAll('[data-tag="ip"]');
    var web_fields = document.querySelectorAll('[data-tag="web"]');
    selected_btn.addEventListener("click", function (event) {
      var selected_item = event.target.querySelector('span');

      if (!selected_item) {
        selected_item = event.target;
      }

      var item_text = selected_item.innerText;
      var is_ip_selected = item_text == 'IP-адрес' || item_text == 'IP address';
      var is_web_app = item_text == 'Web-приложение' || item_text == 'Web application';

      if (is_ip_selected) {
        web_fields.forEach(function (item) {
          item.classList.add('d-none');
        });
        ip_fields.forEach(function (item) {
          item.classList.remove('d-none');
        });
      }

      if (is_web_app) {
        ip_fields.forEach(function (item) {
          item.classList.add('d-none');
        });
        web_fields.forEach(function (item) {
          item.classList.remove('d-none');
        });
      }
    });
  });
}

},{}],15:[function(require,module,exports){
"use strict";

var forms = document.querySelectorAll('[data-form-type="radio"]');

if (forms.length) {
  forms.forEach(function (form) {
    var radioBtns = form.querySelectorAll('input[type="radio"][data-name="conditions"]');
    var sections = form.querySelectorAll('[data-section-id]');
    radioBtns.forEach(function (btn) {
      btn.addEventListener('change', function () {
        changeFields(btn);
      });
    });

    var changeFields = function changeFields() {
      var btn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var checkedBtn = btn ? btn : form.querySelector('input[type="radio"][name="conditions"]:checked');
      var type = checkedBtn.dataset.section;

      switch (type) {
        case 'all':
          sections.forEach(function (section) {
            return section.style.display = 'block';
          });
          break;

        default:
          sections.forEach(function (section) {
            if (section.getAttribute('data-section-id') === type) {
              section.style.display = 'block';
            } else {
              section.style.display = 'none';
            }
          });
      }
    };

    form.querySelector('input[type="radio"][name="conditions"][data-section="all"]').checked = true;
    changeFields();
  });
}

},{}],16:[function(require,module,exports){
"use strict";

var _utils = require("./utils");

(function (window, document, $) {
  // init Bootstrap select
  var $select = $('.selectpicker');
  var selectpicker = $select.selectpicker({
    noneSelectedText: '',
    styleBase: 'form-control',
    width: '100%'
  });
  selectpicker.on('changed.bs.select', function () {
    $select.parents('.bootstrap-select').addClass('selected');
  });
  $(document).on('submit', '.form', function (e) {
    e.preventDefault();
    var $form = $(this),
        isModal = $form.hasClass('form-modal');
    var $modal, $wrapper, $loader;

    if (isModal) {
      $modal = $form.parents('.modal');
      $loader = $modal.find('.loader');
    } else {
      $wrapper = $form.parents('.form-wrapper');
      $loader = $wrapper.find('.loader');
      $modal = $('#successModal');
    }

    $form.find('.error-msg').remove();
    $loader.show();
    var data;
    var honeypot = $form.find('[name="formHoneypot"]');

    if ('radio' === $form.data('formType') && 'all' !== $form.find('input[name="conditions"]:checked').data('section')) {
      var fieldsType = $form.find('input[name="conditions"]:checked').data('section');
      var sections = $form.find('.form-long__section[data-section-id=' + fieldsType + '], .form-long__section:not([data-section-id])');
      data = sections.find(':input').serializeArray();
    } else {
      data = $form.serializeArray();
    }

    if ($(this).hasClass('calculate-modal')) {
      data = data.concat($('.calculate-form').serializeArray());
    }

    if ($(this).hasClass('configurator-modal')) {
      var confData = $('.configurator-form').serializeArray();
      data = data.concat(confData);
    }

    var formData = new FormData();
    data.forEach(function (item) {
      var countryCode = $form.find('.iti__selected-dial-code').text();

      if ((item.name === 'phone' || item.name === 'tel') && countryCode) {
        item.value = countryCode + item.value;
      }

      formData.append(item.name, item.value);
    });

    if ($form.find('input[type="file"]').prop('files')) {
      var file = $form.find('input[type="file"]').prop('files')[0];

      if (file) {
        formData.append('file[]', file);
      }
    }

    if (!honeypot.checked) {
      $.ajax({
        type: 'POST',
        url: $form.attr('action'),
        contentType: false,
        processData: false,
        cache: false,
        data: formData,
        success: function success(response) {
          response = JSON.parse(response);
          $loader.hide();

          if (response.status !== 'error') {
            var counters = response.counters;

            if (counters) {
              var goals = counters.goals;

              if (goals) {
                (0, _utils.sendGoals)(goals.ym ? goals.ym : '', goals.ga, goals.gads, goals.tmr, goals.ga4);
                (0, _utils.sendSocialGoals)({
                  fbGoal: goals.fb,
                  vkGoal: 'submit_application',
                  vkEvent: 'lead'
                });
              }
            }

            if (isModal) {
              var $modalParts = $modal.find('.modal-header,.modal-body,.modal-footer');
              $modalParts.addClass('success');
              setTimeout(function () {
                $form.find('.form-control:not([data-name="conditions"])').val('');
                $modalParts.hide(300);
                $modal.find('.modal-content').append('<div class="response-message"></div>').find('.response-message').append(response.message);
              }, 300);
              $modal.on('hidden.bs.modal', function () {
                $modalParts.removeClass('success');
                $modalParts.show();
                $('.response-message').remove();
              });
            } else {
              $form.find('.form-control:not([data-name="conditions"])').val('');
              $modal.find('.response-message').html(response.message);
              $modal.modal('show');
            }

            if ($form.find('input[name="ebook"]')) {
              var btns = $('[data-download]');
              btns.attr('data-target', '#successModal');
              btns.addClass('allowed');
            }
          } else {
            $.each(response.errors, function (index, value) {
              var $input = $form.find('[name="' + value.field + '"]');

              if ($input.attr('type') !== 'radio') {
                $input.addClass('error').parent().append('<span class="error-msg">' + value.message + '</span>');
              } else {
                $input.addClass('error');
                $input.parents('.form-control-parent').append('<span class="error-msg">' + value.message + '</span>');
              }
            });
          }
        }
      });
    }
  }); // remove errors on input change

  $(document).on('propertychange input change', '.form-control.error', function () {
    $(this).removeClass('error');
    var $parent = $(this).parents('.form-control-parent');
    var $msg = false;

    if ($parent.length > 0) {
      $msg = $parent.find('.error-msg');
    } else {
      $msg = $(this).parent().find('.error-msg');
    }

    $msg.fadeOut(300);
    setTimeout(function () {
      $msg.remove();
    });
  });
  $(document).on('propertychange input change', '.hidden-block-control', function () {
    var $this = $(this);
    var value = $('input[name="' + $(this).attr('name') + '"]:checked').val();
    var $group = $this.parents('.form-long__group');
    var $hiddenBlock = $group.find('.hidden-block');

    if (value === 'Да') {
      $hiddenBlock.addClass('active');
    } else {
      $hiddenBlock.removeClass('active');
    }
  });
})(window, document, jQuery);

},{"./utils":37}],17:[function(require,module,exports){
"use strict";

var _filter = _interopRequireDefault(require("../modules/filter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var links = document.querySelectorAll('.glossary-link:not(.disabled)');
var allItems = document.querySelectorAll('.glossary-item');
var glossaryTags = document.querySelectorAll('.glossary-filter__tag');
var filterOptions = {
  'categoryAttr': 'data-letter'
};

if (links.length) {
  new _filter.default(links, allItems, filterOptions).apply();
}

var glossaryFiltering = function glossaryFiltering(e) {
  e.preventDefault();
  e.target.classList.toggle('active');
  var currLang = document.querySelector('html').getAttribute('lang'); //TODO find better way to detect currLocale

  var currLocale = document.querySelector('.lang-switcher__current').innerHTML;
  var data = new FormData();
  var tags = '';
  glossaryTags.forEach(function (tag) {
    if (tag.classList.contains('active')) {
      tags += tag.getAttribute('data-tag') + ',';
    }
  });
  data.append('tags', tags);
  data.append('action', 'glossary_filter');
  data.append('locale', currLang + '-' + currLocale.toLowerCase());
  var xhr = new XMLHttpRequest();
  xhr.open('POST', '/wp-admin/admin-ajax.php', true);
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.send(data);

  xhr.onreadystatechange = function () {
    if (xhr.readyState === xhr.DONE && xhr.status === 200) {
      if (xhr.responseText) {
        var response = JSON.parse(xhr.responseText);
        document.querySelector('.glossary-letters').innerHTML = response.head;
        document.querySelector('.glossary-body-outer').innerHTML = response.body;

        var _links = document.querySelectorAll('.glossary-link:not(.disabled)');

        new _filter.default(_links, document.querySelectorAll('.glossary-item'), filterOptions).apply();
        document.querySelectorAll('.glossary-filter__tag').forEach(function (tag) {
          tag.addEventListener('click', glossaryFiltering);
        });
      }
    }
  };
};

if (glossaryTags.length) {
  glossaryTags.forEach(function (tag) {
    tag.addEventListener('click', glossaryFiltering);
  });
}

},{"../modules/filter":40}],18:[function(require,module,exports){
"use strict";

addEventListener("DOMContentLoaded", function (event) {
  var langSwitcher = document.getElementById('menu-lang-switcher');
  var topline = document.getElementById('topline');

  if (langSwitcher && topline) {
    var langSwitcherContainer = topline.querySelector('.topline__lang');
    var has_lagswitcher = langSwitcherContainer.querySelector('.lang-switcher');

    if (langSwitcherContainer && !has_lagswitcher) {
      langSwitcherContainer.appendChild(langSwitcher.childNodes[0]);
    }
  }
});

},{}],19:[function(require,module,exports){
"use strict";

var fileInputs = document.querySelectorAll('input[type="file"]');

if (fileInputs.length) {
  fileInputs.forEach(function (input) {
    var fileWrap = input.parentElement;

    if (!fileWrap.classList.contains('input-file-wrap')) {
      fileWrap = fileWrap.parentElement;
    }

    input.addEventListener('change', function (e) {
      var that = e.target;
      var files = that.files;
      var filesStr = '';
      Array.from(files).forEach(function (file, index) {
        if (index) {
          filesStr += ', ';
        }

        filesStr += file.name;
      });
      fileWrap.querySelector('.input-file-wrap__list').textContent = filesStr;
      var fileHolder = fileWrap.querySelector('.input-file-wrap__holder');
      var fileTitle = fileWrap.querySelector('.input-file__title');

      if (input.value) {
        fileHolder.classList.add('visible');
        fileTitle.classList.add('invisible');
      } else {
        fileHolder.classList.remove('visible');
        fileTitle.classList.remove('invisible');
      }
    });
  });
}

},{}],20:[function(require,module,exports){
"use strict";

(function () {
  // Restricts input for the given textbox to the given inputFilter.
  function setInputFilter(textbox, inputFilter) {
    ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function (event) {
      textbox.addEventListener(event, function () {
        if (inputFilter(this.value)) {
          this.oldValue = this.value;
          this.oldSelectionStart = this.selectionStart;
          this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty("oldValue")) {
          this.value = this.oldValue;
          this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        }
      });
    });
  }

  var inputs = document.querySelectorAll('.input-number');
  inputs.forEach(function (item, index) {
    // Restrict input to digits and '.' by using a regular expression filter.
    setInputFilter(inputs[index], function (value) {
      return /^\d*\.?\d*$/.test(value);
    });
  });
  var btnsPlus = document.querySelectorAll('.input-number-plus');
  var btnsMinus = document.querySelectorAll('.input-number-minus');

  var createEvent = function createEvent(input) {
    var event = document.createEvent('Event');
    event.initEvent('input', true, true);
    input.dispatchEvent(event);
  };

  btnsPlus.forEach(function (item) {
    item.addEventListener('click', function () {
      var input = item.parentNode.querySelector('input');
      input.value = +input.value + 1;
      createEvent(input);
    });
  });
  btnsMinus.forEach(function (item) {
    item.addEventListener('click', function () {
      var input = item.parentNode.querySelector('input');
      input.value = input.value == 0 || +input.value === 1 ? '' : +input.value - 1;
      createEvent(input);
    });
  });
})();

},{}],21:[function(require,module,exports){
"use strict";

(function () {
  var lazyImages = [].slice.call(document.querySelectorAll("img.custom-lazy"));

  if ("IntersectionObserver" in window) {
    var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var lazyImage = entry.target;
          setImagesAttribute(lazyImage);
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });
    lazyImages.forEach(function (lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    // fall back to a more compatible method here (basically for IE)
    var _lazyImages = [].slice.call(document.querySelectorAll("img.custom-lazy"));

    var active = false;

    var lazyLoad = function lazyLoad() {
      if (active === false) {
        active = true;
        setTimeout(function () {
          _lazyImages.forEach(function (lazyImage) {
            if (lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0 && getComputedStyle(lazyImage).display !== "none") {
              setImagesAttribute(lazyImage);
              _lazyImages = _lazyImages.filter(function (image) {
                return image !== lazyImage;
              });

              if (_lazyImages.length === 0) {
                document.removeEventListener("scroll", lazyLoad);
                window.removeEventListener("resize", lazyLoad);
                window.removeEventListener("orientationchange", lazyLoad);
              }
            }
          });

          active = false;
        }, 200);
      }
    };

    document.addEventListener("scroll", lazyLoad);
    window.addEventListener("resize", lazyLoad);
    window.addEventListener("load", lazyLoad);
    window.addEventListener("orientationchange", lazyLoad);
  }

  function setImagesAttribute(lazyImage) {
    var imagesDataSrc = {
      'src': lazyImage.getAttribute('data-src'),
      'srcset': lazyImage.getAttribute('data-srcset')
    };

    if (imagesDataSrc.src) {
      lazyImage.src = lazyImage.getAttribute('data-src');
    }

    if (imagesDataSrc.srcset) {
      lazyImage.setAttribute('srcset', lazyImage.getAttribute('data-srcset'));
    }

    lazyImage.classList.remove("custom-lazy");
  }
})();

},{}],22:[function(require,module,exports){
"use strict";

(function () {
  var preventLink = function preventLink(e) {
    e.preventDefault();
  };

  var btn = document.querySelector('.loadmore');

  if (btn) {
    var container = document.querySelector('.ajax-cont');
    var lang = btn.dataset.lang;
    var author = btn.dataset.author ? btn.dataset.author : '';
    var currentPage = 1;

    var getMore = function getMore() {
      var data = {
        'lang': lang,
        'page': currentPage,
        'author': author
      };
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/ajax/loadmore.php', true);
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.setRequestHeader("Content-type", "application/json");

      xhr.onloadstart = function () {
        btn.removeEventListener('click', getMore);
      };

      xhr.send(JSON.stringify(data));

      xhr.onreadystatechange = function () {
        if (xhr.readyState === xhr.DONE && xhr.status === 200) {
          var response = JSON.parse(xhr.responseText);

          if (response) {
            response['posts'].forEach(function (item, index) {
              container.insertAdjacentHTML('beforeend', item);
            });

            if (response['lastPage']) {
              btn.remove();
            }

            currentPage++;
          }

          btn.addEventListener('click', getMore);
        }
      };
    };

    btn.addEventListener('click', getMore);
    btn.addEventListener('click', preventLink);
  }
})();

},{}],23:[function(require,module,exports){
"use strict";

(function () {
  var dc_list = document.getElementById('dc-list');

  if (dc_list) {
    (function () {
      var items = dc_list.children;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var item = _step.value;
          item.addEventListener('click', function (e) {
            var visability = item.dataset.visability;

            if (visability == 'false') {
              //close all 
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var element = _step2.value;
                  element.setAttribute('data-visability', 'false');
                  element.classList.add('map-dc--invisible');
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }

              item.setAttribute('data-visability', 'true');
              item.classList.remove('map-dc--invisible');
            } else {
              item.setAttribute('data-visability', 'false');
              item.classList.add('map-dc--invisible');
            }
          });
        };

        for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    })();
  }
})();

},{}],24:[function(require,module,exports){
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

(function (window, document, $) {
  var $menu = $('#mobileMenu');
  var $body = $('body');
  var mobileMenuSectionList = document.querySelectorAll('.mobile-menu__section-list');
  var mobileMenuBody = document.querySelector('#mobile-menu-body');
  var disableBodyScroll = bodyScrollLock.disableBodyScroll;
  var enableBodyScroll = bodyScrollLock.enableBodyScroll;
  $('#mobileOpen').on('click', function () {
    $body.addClass('modal-open');
    $menu.fadeIn(0);
    setTimeout(function () {
      $menu.toggleClass('show');
      disableBodyScroll(mobileMenuBody);
    }, 0);
  });
  $('#mobileClose').on('click', function () {
    closeMenu();
  });
  $('.has-items').on('click', function () {
    $(this).next('.mobile-menu__section').addClass('show');
    enableBodyScroll(mobileMenuBody);

    _toConsumableArray(mobileMenuSectionList).map(function (el) {
      return disableBodyScroll(el);
    });
  });
  $('.mobile-menu__section-title').on('click', function () {
    $(this).parents('.mobile-menu__section').removeClass('show');
    setTimeout(function () {
      $menu.find('#mobile-menu-body .collapse.show').collapse('hide');

      _toConsumableArray(mobileMenuSectionList).map(function (el) {
        return enableBodyScroll(el);
      });

      disableBodyScroll(mobileMenuBody);
    }, 150);
  });
  $(document).on('click', function (e) {
    if (!$menu.is(e.target) && $menu.has(e.target).length === 0 && $menu.hasClass('show')) {
      closeMenu();
    }
  });

  function closeMenu() {
    $body.removeClass('modal-open');
    $menu.removeClass('show');
    setTimeout(function () {
      $menu.fadeOut(0);
      $menu.find('.collapse.show').collapse('hide');
      $('.mobile-menu__section.show').removeClass('show');
      bodyScrollLock.clearAllBodyScrollLocks();
    }, 200);
  }
})(window, document, jQuery);

},{}],25:[function(require,module,exports){
"use strict";

var _utils = require("./utils");

(function (window, document, $) {
  $('[data-toggle="modal"]').on('click', function () {
    var $this = $(this);
    var target = $this.data('target');
    var $modal = $(target);
    var $form = $modal.find('.form-modal');
    var $ebook = $modal.find('input[name=ebook]');
    var downloadAttr = $this.attr('data-id');
    var sendpulseBook = $this.attr('data-sendpulse-book');
    var unisenderListId = $this.attr('data-unisender-list');

    if ($form) {
      var currModal = document.querySelector('.modal');
      var sendpulseField = currModal ? currModal.querySelector('input[name="sendpulseBookId"]') : '';

      if (sendpulseBook) {
        if (sendpulseField) {
          sendpulseField.setAttribute('value', sendpulseBook);
        } else {
          $form.append('<input type="hidden" name="sendpulseBookId" value="' + sendpulseBook + '">');
        }
      } else if (sendpulseField) {
        sendpulseField.setAttribute('value', '');
      }

      var unisenderField = currModal ? currModal.querySelector('input[name="unisenderListId"]') : '';

      if (unisenderListId) {
        if (unisenderField) {
          unisenderField.setAttribute('value', unisenderListId);
        } else {
          $form.append('<input type="hidden" name="unisenderListId" value="' + unisenderListId + '">');
        }
      } else if (unisenderField) {
        unisenderField.setAttribute('value', '');
      }
    }

    if (!$ebook.length && target !== '#empty-modal' && downloadAttr === undefined) {
      var dataTitle = $this.data('title');
      $modal.find('.modal-header--title').html(dataTitle || $this.text());
    }

    if (target === '#empty-modal') {
      $modal.find('.modal-header--title').text($this.parents('.license__item').find('.license__title').text());
      $modal.find('.modal-body').html('<div class="content-wrapper">' + $this.data('content') + '');
      $modal.find('.modal-body').append('<div class="img-wrapper"><a href="' + $this.data('img') + '" data-fancybox><img src="' + $this.data('img') + '"></a></div></div>');
    }

    if (downloadAttr) {
      $ebook.val(downloadAttr);
      $modal.find('input[name=id]').val($this.attr('data-form-id'));
    }

    (0, _utils.sendSocialGoals)({
      fbGoal: 'InitiateCheckout',
      vkGoal: 'initiate_checkout',
      vkEvent: 'click'
    });
  });
})(window, document, jQuery);

},{"./utils":37}],26:[function(require,module,exports){
"use strict";

/**
 * Owl init
 */
(function (window, document, $) {
  var $carousel1x = $('.carousel-1x');
  var $carousel6x = $('.carousel-6x');
  var $pageCarousel = $('.page-carousel');
  var $mainCarousel = $('.main-screen__carousel');

  var carouselReInit = function carouselReInit(args) {
    var innerWidth = document.body.offsetWidth;
    var $carousel = $('.carousel-1x.carousel-none-xl:not(.owl-loaded)');
    var $carouselLoaded = $('.carousel-1x.carousel-none-xl');

    if (innerWidth > 1199) {
      $carouselLoaded.trigger('destroy.owl.carousel');
      $carouselLoaded.addClass('row');
    } else {
      $carousel.owlCarousel(args);
      $carousel.removeClass('row');
    }
  };

  if ($carousel1x.length) {
    $carousel1x.each(function () {
      var autoplay = $(this).hasClass('main-about__carousel');
      var carousel1Args = {
        loop: true,
        autoplay: false,
        items: 1,
        nav: true,
        navText: ['<?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21.8 17.8" style="enable-background:new 0 0 21.8 17.8;" xml:space="preserve"><style type="text/css">.st0{fill:#338FFA;}</style><polygon class="st0" points="12.9,0 11.1,1.8 17,7.6 0,7.6 0,10.1 17,10.1 11.1,16 12.9,17.8 21.8,8.9 "/></svg>', '<?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21.8 17.8" style="enable-background:new 0 0 21.8 17.8;" xml:space="preserve"><style type="text/css">.st0{fill:#338FFA;}</style><polygon class="st0" points="12.9,0 11.1,1.8 17,7.6 0,7.6 0,10.1 17,10.1 11.1,16 12.9,17.8 21.8,8.9 "/></svg>'],
        animateIn: 'fadeIn',
        lazyLoad: true,
        responsive: {
          0: {
            dots: true
          },
          768: {
            dots: true,
            mouseDrag: false
          },
          1200: autoplay ? {
            autoplay: true,
            autoplayHoverPause: true,
            autoplaySpeed: 5000
          } : {}
        }
      };
      $(this).owlCarousel(carousel1Args);
      var shadowedElementClass = 'owl-stage-outer__shadow';
      $(this).append('<div class="' + shadowedElementClass + '"></div>');
      var $shadowElement = $(this).find('.' + shadowedElementClass);
      $(this).find('.owl-stage-outer').on('mouseover', function () {
        var $this = $(this);
        $this.find('.owl-item.active').find('.cases__link').addClass('hovered');
        var currentSlideHeight = $this.find('.owl-item.active').height();
        $shadowElement.height(currentSlideHeight).addClass('shadowed');
      }).on('mouseleave', function () {
        $(this).find('.owl-item.active').find('.cases__link').removeClass('hovered');
        $shadowElement.removeClass('shadowed');
      });
      carouselReInit(carousel1Args);
      window.addEventListener('resize', function () {
        carouselReInit(carousel1Args);
      });
    });
  }

  if ($pageCarousel.length) {
    $pageCarousel.each(function () {
      var pageCarouselArgs = {
        loop: true,
        autoplay: false,
        items: 1,
        nav: true,
        navText: ['<?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21.8 17.8" style="enable-background:new 0 0 21.8 17.8;" xml:space="preserve"><style type="text/css">.st0{fill:#338FFA;}</style><polygon class="st0" points="12.9,0 11.1,1.8 17,7.6 0,7.6 0,10.1 17,10.1 11.1,16 12.9,17.8 21.8,8.9 "/></svg>', '<?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21.8 17.8" style="enable-background:new 0 0 21.8 17.8;" xml:space="preserve"><style type="text/css">.st0{fill:#338FFA;}</style><polygon class="st0" points="12.9,0 11.1,1.8 17,7.6 0,7.6 0,10.1 17,10.1 11.1,16 12.9,17.8 21.8,8.9 "/></svg>'],
        animateIn: 'fadeIn',
        lazyLoad: true,
        responsive: {
          0: {
            dots: true
          },
          768: {
            dots: true,
            mouseDrag: false
          },
          1200: {
            dots: true,
            mouseDrag: false
          }
        }
      };
      $(this).owlCarousel(pageCarouselArgs);
      $(this).find('.owl-stage-outer').on('mouseover', function () {
        var $this = $(this);
        $this.find('.owl-item.active').find('.cases__link').addClass('hovered');
      }).on('mouseleave', function () {
        $(this).find('.owl-item.active').find('.cases__link').removeClass('hovered');
      });
      carouselReInit(pageCarouselArgs);
      window.addEventListener('resize', function () {
        carouselReInit(pageCarouselArgs);
      });
    });
  }

  if (!$mainCarousel.length) {
    $mainCarousel.owlCarousel({
      loop: true,
      center: true,
      autoplay: false,
      items: 1,
      nav: false,
      dots: false,
      autoWidth: true,
      animateIn: 'fadeIn',
      onInitialized: function onInitialized() {
        setTimeout(function () {
          $mainCarousel.find('.owl__item').addClass('show');
        }, 300);
      }
    });
  }

  if ($carousel6x.length) {
    $carousel6x.owlCarousel({
      loop: true,
      center: false,
      autoplay: false,
      items: 6,
      nav: true,
      navText: ['<?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21.8 17.8" style="enable-background:new 0 0 21.8 17.8;" xml:space="preserve"><style type="text/css">.st0{fill:#338FFA;}</style><polygon class="st0" points="12.9,0 11.1,1.8 17,7.6 0,7.6 0,10.1 17,10.1 11.1,16 12.9,17.8 21.8,8.9 "/></svg>', '<?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21.8 17.8" style="enable-background:new 0 0 21.8 17.8;" xml:space="preserve"><style type="text/css">.st0{fill:#338FFA;}</style><polygon class="st0" points="12.9,0 11.1,1.8 17,7.6 0,7.6 0,10.1 17,10.1 11.1,16 12.9,17.8 21.8,8.9 "/></svg>'],
      dragMove: false,
      lazyLoad: true,
      responsive: {
        0: {
          items: 2,
          dots: true,
          dotsEach: 3
        },
        768: {
          items: 3,
          dots: true,
          mouseDrag: false
        },
        992: {
          slideBy: 3,
          items: 6,
          dots: true,
          mouseDrag: false
        }
      }
    });
  }

  var $carouselMobile = $('.carousel-mobile');

  if ($carouselMobile.length) {
    var args = {
      items: 1,
      loop: true,
      dots: true,
      autoWidth: true,
      center: true
    };

    var carouselMobileEnable = function carouselMobileEnable(args) {
      var innerWidth = document.body.offsetWidth;
      var $carousel = $('.carousel-mobile:not(.owl-loaded)');
      var $carouselLoaded = $('.carousel-mobile');

      if (innerWidth > 991) {
        $carouselLoaded.trigger('destroy.owl.carousel');
        $carouselLoaded.addClass('row');
        $carousel.removeClass('owl-carousel');
      } else {
        $carousel.owlCarousel(args);
        $carousel.removeClass('row');
        $carousel.addClass('owl-carousel');
      }
    };

    carouselMobileEnable(args);
    window.addEventListener('resize', function () {
      carouselMobileEnable(args);
    });
  }

  var $carouselMobile1x = $('.carousel-mobile-1x');

  if ($carouselMobile1x.length) {
    var _args = {
      items: 1,
      loop: true,
      dots: true,
      center: true
    };

    var _carouselMobileEnable = function _carouselMobileEnable(args) {
      var innerWidth = document.body.offsetWidth;
      var $carousel = $('.carousel-mobile-1x:not(.owl-loaded)');
      var $carouselLoaded = $('.carousel-mobile-1x');

      if (innerWidth > 991) {
        $carouselLoaded.trigger('destroy.owl.carousel');
        $carouselLoaded.addClass('row');
        $carousel.removeClass('owl-carousel');
      } else {
        $carousel.owlCarousel(args);
        $carousel.removeClass('row');
        $carousel.addClass('owl-carousel');
      }
    };

    _carouselMobileEnable(_args);

    window.addEventListener('resize', function () {
      _carouselMobileEnable(_args);
    });
  }

  $('.card-tab').on('mouseover', function () {
    //$mainCarousel.trigger('to.owl.carousel', $(this).data('id'));
    // document.querySelector('.main-screen__carousel img').src = $(this).attr('data-img');
    $('.ms-item').removeClass('active');
    var $this = $(this);
    $('#ms-item-' + $this.data('id') + '').addClass('active');
  });
  $('.owl-carousel').each(function () {
    //Find each set of dots in this carousel
    $(this).find('.owl-dot').each(function (index) {
      //Add one to index so it starts from 1
      $(this).attr('aria-label', 'Go to slider number ' + (index + 1));
    });
  });
})(window, document, jQuery);

},{}],27:[function(require,module,exports){
"use strict";

if (!Element.prototype.closest) {
  Element.prototype.closest = function (css) {
    var node = this;

    while (node) {
      if (node.matches(css)) return node;else node = node.parentElement;
    }

    return null;
  };
}

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector;
}

if ('NodeList' in window && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;

    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

},{}],28:[function(require,module,exports){
"use strict";

var quizForm = document.querySelector('.quiz');

var quizHandler = function quizHandler(quiz, action) {
  var data = new FormData(quiz);
  data.append('action', action);
  var xhr = new XMLHttpRequest();
  xhr.open('POST', '/wp-admin/admin-ajax.php', true);
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.send(data);

  xhr.onreadystatechange = function () {
    if (xhr.readyState === xhr.DONE && xhr.status === 200) {
      var response = JSON.parse(xhr.responseText);

      if (response) {
        if (response['refresh']) {
          document.location.reload();
        } else {
          document.querySelector('.quiz__inner').innerHTML = response;
          var answers = document.querySelectorAll('.quiz-question input[type="radio"]');
          answers.forEach(function (item) {
            item.addEventListener('change', function (e) {
              answerHandler();
            });
          });
          quizForm.removeEventListener('click', quizHandler);
        }
      }
    }
  };
};

var answerHandler = function answerHandler() {
  var form = document.querySelector('.quiz');
  var data = new FormData(form);
  data.append('action', 'quiz_answer_validate');
  configurator - modal;
  var xhr = new XMLHttpRequest();
  xhr.open('POST', '/wp-admin/admin-ajax.php', true);
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.send(data);

  xhr.onreadystatechange = function () {
    if (xhr.readyState === xhr.DONE && xhr.status === 200) {
      var response = JSON.parse(xhr.responseText);

      if (response) {
        var btn = '<button type="button" class="btn btn--filled">' + response['btn_text'] + '</button>';
        var explanation = '<div>' + response['explanation'] + '</div>';
        var questionBlock = document.querySelector('.quiz-question');
        questionBlock.querySelector('.quiz-question__header').innerHTML = response['text'];
        questionBlock.querySelector('.quiz-question__footer').innerHTML = explanation + btn;
        var answers = questionBlock.querySelectorAll('input[type="radio"]');
        var correctClass = 'correct';
        answers[+response['rightAnswer']].parentElement.classList.add('correct');
        answers.forEach(function (answer, index) {
          if (answer.checked && index !== +response['rightAnswer']) {
            answer.parentElement.classList.add('incorrect');
            correctClass = 'incorrect';
          }

          answer.disabled = true;
          answer.parentElement.classList.add('disabled');
        });
        questionBlock.classList.add(correctClass);
        questionBlock.classList.add('answered');
        var questionNumInput = form.querySelector('input[name="questionNum"]');
        questionNumInput.value = +questionNumInput.value + 1;
        questionBlock.addEventListener('click', function (e) {
          quizHandler(quizForm, 'quiz_question');
        });
      }
    }
  };
};

if (quizForm) {
  var startBtn = document.querySelector('.quiz__start');
  var answers = document.querySelectorAll('.quiz-question input[type="radio"]');

  if (answers.length) {
    answers.forEach(function (item) {
      item.addEventListener('change', function (e) {
        answerHandler();
      });
    });
  }

  if (startBtn) {
    startBtn.addEventListener('click', function (e) {
      quizHandler(quizForm, 'quiz_question');
    });
  }
}

},{}],29:[function(require,module,exports){
"use strict";

var ranges = document.querySelectorAll('.range-control');

var rangeChanging = function rangeChanging(e) {
  var slider = e.target;
  var textInput = slider.nextElementSibling;
  textInput.value = slider.value;
};

ranges.forEach(function (item) {
  var slider = item.querySelector('input[type="range"]');

  if (slider) {
    slider.addEventListener('change', rangeChanging);
    slider.addEventListener('input', rangeChanging);
  }
});

},{}],30:[function(require,module,exports){
"use strict";

var $stars = $('.rating-active');

if ($stars.length) {
  var $star = $stars.find('.rating-star');
  var id = $stars.data('id'); // const $ratingVotes = $('.rating__votes');

  $star.on('click', function () {
    if (!Cookies.get('rated-post-' + id)) {
      var starRate = $(this).data('rate');
      $.post('/ajax/rating.php', {
        id: id,
        rating: starRate
      }, function (response) {
        response = JSON.parse(response);

        if (response.status === 'success') {
          $stars.addClass('disabled');
          Cookies.set('rated-post-' + id, starRate, {
            expires: 365,
            path: '/'
          }); //$ratingVotes.find('.rate').text(response.rate);
          //$ratingVotes.find('.count').text(response.count);

          $('.rating-count').text(response.count);
          $('meta[name="rating-rate"]').attr('content', response.rate);
          $.each($star, function (index, star) {
            if (starRate >= parseInt($(star).data('rate'), 10)) {
              $(star).addClass('full');
            } else if ($(star).hasClass('full')) {
              $(star).removeClass('full');
            }
          });
        }
      });
    }
  });
}

},{}],31:[function(require,module,exports){
"use strict";

(function (window, document, $) {
  var $slider = $('.royalSlider');
  var sliders = [];

  if ($slider.length) {
    $.each($slider, function () {
      var slider = $(this).royalSlider({
        controlNavigation: 'thumbnails',
        imageScaleMode: 'fill',
        arrowsNav: false,
        //arrowsNavHideOnTouch: true,
        //arrowsNavAutoHide: false,
        fullscreen: false,
        loop: false,
        thumbs: {
          firstMargin: true,
          paddingBottom: 0
        },
        numImagesToPreload: 3,
        thumbsFirstMargin: false,
        autoScaleSlider: false,
        keyboardNavEnabled: true,
        navigateByClick: true,
        fadeinLoadedSlide: true
      });
      slider.prepend($(this).find('.rsNav'));
      sliders.push(slider);
    });
  }
})(window, document, jQuery);

},{}],32:[function(require,module,exports){
"use strict";

(function (window, document, $) {
  // Smooth scroll to #
  $('a[href^="#"]').on('click', function (e) {
    var $link = $(this);
    var target = $link.attr('href');

    if (target !== '#' && $(target).length) {
      $link.addClass('activating');
      $('html, body').animate({
        scrollTop: $(target).offset().top - 80
      }, 800, function () {
        $link.removeClass('activating');
      });
    }

    e.preventDefault();
  });
  var $body = $('body');
  var $rightTabs = $('#rightTabs'); // init bootstrap scroll spy

  if ($rightTabs.length) {
    $body.scrollspy({
      target: '#rightTabs',
      offset: 180
    });
  }

  document.querySelectorAll('[data-item="link"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      var targetSelector = '';

      if (this.dataset.type === "footer") {
        targetSelector = '.form-wrapper';
      } else {
        targetSelector = '#' + this.dataset.type;
      }

      if (!targetSelector) {
        return;
      }

      var attempts = 0;
      var maxAttempts = 50;
      var interval = setInterval(function () {
        var target = document.querySelector(targetSelector);

        if (target) {
          clearInterval(interval);
          target.scrollIntoView({
            behavior: 'smooth'
          });
        }

        attempts++;

        if (attempts >= maxAttempts) {
          clearInterval(interval);
        }
      }, 100);
    });
  });
})(window, document, jQuery);

},{}],33:[function(require,module,exports){
"use strict";

/**
 * Search input
 */
(function (window, document, $) {
  var $searchForm = $('.search-form'); //const $searchClose = $searchForm.find('.search-close');
  //const $searchField = $searchForm.find('input');

  $('.search-toggle').on('click', function (e) {
    var $searchForm = $(this).parents('.search-form');

    if (!$(this).parents('.search-form').hasClass('active')) {
      $searchForm.addClass('active');
      setTimeout(function () {
        $searchForm.find('input').focus();
      }, 300);
    } else if ($(this).parents('.search-form')) {
      $searchForm.removeClass('active');
    }
  });
  $('.search-close').on('click', function (e) {
    if (e.target.classList.contains('find')) {
      e.target.closest('form').submit();
    } else {
      e.target.closest('form').classList.remove('active');
    }
  });
  $('.search-form input').on('input', function (e) {
    var $searchForm = $(e.target).parents('.search-form');
    var $searchClose = $searchForm.find('.search-close');

    if (e.target.value !== '') {
      $searchClose.addClass('find');
    } else {
      $searchClose.removeClass('find');
    }
  });
  $(document).on('click', function (e) {
    var $target = $(e.target);

    if (!$target.hasClass('search-close') && !$target.hasClass('search') && !$target.hasClass('search-toggle') && !$target.closest('.search-toggle').length) {
      $searchForm.removeClass('active');
    }
  });
})(window, document, jQuery);

},{}],34:[function(require,module,exports){
"use strict";

var footerCols = document.querySelectorAll('.footer-main .col');
var socials = document.querySelector('.footer-socials');

if (footerCols.length && window.innerWidth > 991 && socials && footerCols[0].offsetHeight < footerCols[footerCols.length - 1].offsetHeight) {
  socials.classList.add('footer-socials_left');
}

},{}],35:[function(require,module,exports){
"use strict";

var _scrollTo = _interopRequireDefault(require("../modules/scrollTo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (window, document, $) {
  var $tabs = $(".tabs");

  if ($tabs.length) {
    $.each($tabs, function () {
      $(this).find(".nav-link").first().addClass("active");
      $(this).find(".tab-pane").first().addClass("active show");
    });
  }

  $(document).delegate(".tabs_vertical__nav .nav-link--title", "click", function (e) {
    e.preventDefault();
    $(this).tab("show");
  });
  $('[data-toggle="tab"]').on("click", function () {
    var $scrollArea = $(this).parent();
    var $this = $(this);
    var areaWidth = $scrollArea.width();
    var targetWidth = $this.outerWidth(true);
    var index = $this.index();
    var elements = $scrollArea.find('[data-toggle="tab"]');
    var elsWidth = 0;

    for (var i = 0; i < index; i++) {
      elsWidth += $(elements[i]).outerWidth(true);
    }

    var leftOffset = elsWidth - (areaWidth - targetWidth) / 2;
    $scrollArea.animate({
      scrollLeft: leftOffset
    });
  });
  var tabsArrows = document.querySelectorAll(".tabs .nav-arrow") || [];
  tabsArrows.forEach(function (arrow) {
    arrow.addEventListener("click", function () {
      if (arrow.classList.contains("nav-arrow--prev")) {
        var prev = arrow.closest(".tabs").querySelector(".active").previousElementSibling;

        if (prev) {
          $(prev).tab("show");
        }
      } else {
        var next = arrow.closest(".tabs").querySelector(".active").nextElementSibling;

        if (next) {
          $(next).tab("show");
        }
      }
    });
  });
  $(".tabs_vertical__nav a:first-of-type").tab("show");
  var scrollableTabsLinks = document.querySelectorAll('.tabs_vertical_scrollable [data-toggle="tab"]');

  if (window.innerWidth > 768 && scrollableTabsLinks.length) {
    scrollableTabsLinks.forEach(function (link) {
      link.addEventListener("click", function () {
        var target = document.querySelector(link.getAttribute("data-target"));
        (0, _scrollTo.default)(target, 400);
      });
    });
  }

  var saveVerticalTabs = function saveVerticalTabs(selector) {
    var tabsVerticalArr = selector;
    var tabsVOriginals = [];

    for (var i = 0; i < tabsVerticalArr.length; i++) {
      tabsVOriginals.push(tabsVerticalArr[i].cloneNode(true));
    }

    return tabsVOriginals;
  };

  var tabsVOriginals = saveVerticalTabs(document.querySelectorAll(".tabs_vertical"));

  var tabsToAccordion = function tabsToAccordion() {
    if (window.innerWidth < 768) {
      $(".tabs_vertical [data-target]").each(function () {
        $(this).addClass("collapsed accordion__btn");
        $(this).attr("data-toggle", "collapse");
        $(this).attr("aria-expanded", "false");
        $(this).append('<img src="/assets/img/svg/arrow-d-big.svg">');
      });
      $(".tabs_vertical .tab-pane").each(function () {
        var $parent = $(this).parents(".tabs_vertical");
        var $relatedElement = $parent.find('.nav-link--title[data-target="#' + $(this).attr("id") + '"]');
        $(this).addClass("accordion__tab collapse");
        $(this).removeClass("tab-pane fade active show");
        $(this).detach().insertAfter($relatedElement);
      });
      $(".tabs_vertical").addClass("accordion ex_tabs_vertical").removeClass("tabs_vertical");
      $(".tabs_vertical__head").removeClass("tabs_vertical__head");
      $(".tabs_vertical__nav.nav").removeClass("tabs_vertical__nav nav");
    } else {
      var $exTabs = $(".ex_tabs_vertical");

      if ($exTabs.length) {
        $exTabs.each(function (index) {
          $(this).after(tabsVOriginals[index]);
          $(this).remove();
        });
        tabsVOriginals = saveVerticalTabs(document.querySelectorAll(".tabs_vertical"));
        $(".tabs_vertical__nav [data-target]:first-of-type").tab("show");
      }
    }
  };

  tabsToAccordion();
  $(window).on("resize", function () {
    tabsToAccordion();
  });
})(window, document, jQuery);

},{"../modules/scrollTo":41}],36:[function(require,module,exports){
"use strict";

(function () {
  var content = document.querySelector('.content');
  var upLink = document.querySelector('.up-link');

  var getCoords = function getCoords() {
    var coords = content.getBoundingClientRect();
    return {
      right: coords.right,
      top: coords.top + pageYOffset
    };
  };

  var goToTop = function goToTop(e) {
    e.preventDefault();
    window.scrollTo({
      top: getCoords().top,
      behavior: 'smooth'
    });
  };

  if (upLink) {
    upLink.addEventListener('click', goToTop);

    var moveUpLink = function moveUpLink(coords) {
      upLink.style.left = coords + 'px';
    };

    moveUpLink(getCoords().right);

    window.onresize = function () {
      moveUpLink(getCoords().right);
    };
  }
})();

},{}],37:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendSocialGoals = exports.sendFBGoal = exports.sendVKGoal = exports.sendGoals = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var localYmCounterKey = '';

var _tmr = window._tmr || (window._tmr = []);

window.dataLayer = window.dataLayer || [];

window.gtag = function () {
  dataLayer.push(arguments);
};

window.addEventListener("load", function () {
  var ymCountersKeys = Object.keys(window).filter(function (el) {
    return /^yaCounter.*?/i.test(el);
  });
  localYmCounterKey = ymCountersKeys[0];
});

var sendGoals = function sendGoals(ymGoal, gaGoal, gadsGoal, tmrGoal, ga4Goal) {
  if (Array.isArray(ymGoal)) {
    ymGoal.forEach(function (goal) {
      return sendYMGoal(goal);
    });
  } else {
    sendYMGoal(ymGoal);
  }

  if (typeof gtag !== 'undefined' && ga4Goal && typeof ga4Goal !== 'undefined' && ga4Goal.id !== '') {
    var $params = {};

    if (ga4Goal.params) {
      ga4Goal.params.forEach(function (param) {
        $params[param.key] = param.value;
      });
    }

    gtag("event", ga4Goal.id, $params);
  } // if (typeof ga === 'function' && typeof gaGoal !== 'undefined' && typeof gaGoal.label !== 'undefined' && typeof gaGoal.action !== 'undefined' && typeof gaGoal.category !== 'undefined') {
  //   ga('send', 'event', gaGoal.category, gaGoal.action, gaGoal.label);
  // }


  if (gadsGoal) {
    if (typeof gtag !== 'undefined' && typeof gadsGoal !== 'undefined' && typeof gadsGoal.goal !== 'undefined' && typeof gadsGoal.id !== 'undefined') {
      gtag('event', 'conversion', {
        'send_to': gadsGoal.id + '/' + gadsGoal.goal
      });
    }
  }

  if (_typeof(_tmr) === 'object' && tmrGoal) {
    sendTMRGoal(tmrGoal.id, tmrGoal.goal);
  }
};

exports.sendGoals = sendGoals;

function sendYMGoal(goal) {
  if (goal && window[localYmCounterKey]) {
    window[localYmCounterKey].reachGoal(goal);
  }
}

var sendTMRGoal = function sendTMRGoal(id, goal) {
  if (_tmr && goal) {
    _tmr.push({
      id: id,
      type: "reachGoal",
      goal: goal
    });
  }
};

var sendVKGoal = function sendVKGoal(goal) {
  if ((typeof VK === "undefined" ? "undefined" : _typeof(VK)) === 'object') {
    VK.Goal(goal);
  }
};

exports.sendVKGoal = sendVKGoal;

var sendVKEvent = function sendVKEvent(goal) {
  if ((typeof VK === "undefined" ? "undefined" : _typeof(VK)) === 'object' && VK.Retargeting) {
    VK.Retargeting.Event(goal);
  }
};

var sendFBGoal = function sendFBGoal(goal) {
  if (typeof fbq === 'function' && goal) {
    fbq('track', goal);
  }
};

exports.sendFBGoal = sendFBGoal;

var sendSocialGoals = function sendSocialGoals(_ref) {
  var fbGoal = _ref.fbGoal,
      vkGoal = _ref.vkGoal,
      vkEvent = _ref.vkEvent;
  if (fbGoal) sendFBGoal(fbGoal);
  if (vkGoal) sendVKGoal(vkGoal);
  if (vkEvent) sendVKEvent(vkEvent);
};

exports.sendSocialGoals = sendSocialGoals;

},{}],38:[function(require,module,exports){
"use strict";

var videoBlocks = document.querySelectorAll('[data-toggle="video"]');

if (videoBlocks.length) {
  videoBlocks.forEach(function (videoBlock) {
    videoBlock.addEventListener("click", function (e) {
      e.preventDefault();
      var videoId = videoBlock.getAttribute("data-youtube-id");

      if (!videoBlock.classList.contains("loaded")) {
        videoBlock.querySelector("#video-trigger").classList.add("d-none");

        if (videoBlock.getAttribute("data-with-iframe") == "true") {
          var frame = videoBlock.querySelector(".video__frame");
          var uncomment_frame = frame.innerHTML.toString().replace(/<!--\s*/g, "").replace(/\s*-->/g, "");
          videoBlock.insertAdjacentHTML("beforeend", uncomment_frame);
        } else {
          videoBlock.insertAdjacentHTML("beforeend", '<iframe width="100%" height="100%" src="//www.youtube.com/embed/' + videoId + '?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
        }

        setTimeout(function () {
          videoBlock.classList.add("loaded");
        }, 100);
      }
    });
  });
}

},{}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMobileDevice = isMobileDevice;
exports.inViewport = inViewport;
exports.numberThousandSeparator = numberThousandSeparator;
exports.isDomElement = isDomElement;
exports.default = void 0;

/**
 * @param {String} data
 *
 * @return {String}
 */
var _default = Element.prototype.data = function (data) {
  return this.getAttribute('data-' + data);
};
/**
 * @return {Boolean}
 */


exports.default = _default;

function isMobileDevice() {
  return typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
}
/**
 * @param {Element} element
 *
 * @return {Boolean}
 */


function inViewport(element) {
  return !(element.getBoundingClientRect().top > innerHeight || element.getBoundingClientRect().bottom < 0);
}
/**
 * @param {Number} n
 *
 * @return {String}
 */


function numberThousandSeparator(n) {
  return n.toString().replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1 ');
}
/**
 * @param {Element} element
 *
 * @return {Boolean}
 */


function isDomElement(element) {
  return element instanceof Element || element instanceof HTMLDocument;
}

},{}],40:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Filter =
/*#__PURE__*/
function () {
  function Filter(categories, allItems, options) {
    _classCallCheck(this, Filter);

    if (NodeList.prototype.isPrototypeOf(categories)) {
      this.links = categories;
    } else {
      this.select = categories;
    }

    this.allItems = allItems;
    this.options = {
      'categoryAttr': options && options['categoryAttr'] ? options['categoryAttr'] : 'data-filter'
    };
  }

  _createClass(Filter, [{
    key: "_setListeners",
    value: function _setListeners(event) {
      var _this = this;

      event.preventDefault();
      var category = '';

      if (this.links) {
        category = event.target.getAttribute(this.options['categoryAttr']);
        this.links.forEach(function (linkInner) {
          linkInner.classList.remove('active');

          if (linkInner.getAttribute(_this.options['categoryAttr']) === category) {
            linkInner.classList.add('active');
          }
        });
      } else {
        category = event.target.value;
      }

      if (category !== 'all' && category !== '') {
        this.allItems.forEach(function (catItem) {
          catItem.classList.add('inactive');
          var itemCategories = catItem.getAttribute(_this.options['categoryAttr']).split(', ');
          if (itemCategories.indexOf(category) !== -1) catItem.classList.remove('inactive');
        });
      } else {
        this.allItems.forEach(function (catItem) {
          catItem.classList.remove('inactive');
        });
      }
    }
  }, {
    key: "apply",
    value: function apply() {
      var _this2 = this;

      if (this.links) {
        this.links.forEach(function (category) {
          category.addEventListener('click', function (e) {
            return _this2._setListeners(e);
          });
        });
      } else {
        this.select.addEventListener('change', function (e) {
          return _this2._setListeners(e);
        });
      }
    }
  }]);

  return Filter;
}();

var _default = Filter;
exports.default = _default;

},{}],41:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTo;

var _functions = require("./_functions");

function scrollTo(element, duration) {
  if (element && ((0, _functions.isDomElement)(element) || document.querySelector(element))) {
    var target = (0, _functions.isDomElement)(element) ? element : document.querySelector(element);
    var startingY = window.pageYOffset;
    var elementY = window.pageYOffset + target.getBoundingClientRect().top;
    var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY - document.querySelector('header').getBoundingClientRect().height;
    var diff = targetY - startingY; // Easing function: easeInOutCubic
    // From: https://gist.github.com/gre/1650294

    var easing = function easing(t) {
      return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    };

    var start;

    if (diff) {
      // Bootstrap our animation - it will get called right before next frame shall be rendered.
      window.requestAnimationFrame(function step(timestamp) {
        if (!start) {
          start = timestamp;
        }

        var time = timestamp - start;
        var percent = Math.min(time / duration, 1);
        percent = easing(percent);
        window.scrollTo(0, startingY + diff * percent);

        if (time < duration) {
          window.requestAnimationFrame(step);
        }
      });
    }
  }
}

},{"./_functions":39}]},{},[1]);
